import { fromJS } from 'immutable';
import { ACTION } from './constants';

const initialState = {
};

function evaluableReducer(state = fromJS(initialState), action) {
  switch (action.type) {
    case ACTION.AUTHOR_EVALUABLE_PUT:
      return state
        .set(action.elementId, { elementType: action.elementType, elementId: action.elementId, evaluationMode: action.evaluationMode });
    default:
      return state;
  }
}

export {
  initialState,
};

export default evaluableReducer;
